module.exports = __webpack_public_path__ + "static/media/RLC_8486a.18f1e6ed.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/kukenan/RLC_8486a.JPG
// module id = 102
// module chunks = 0